module.exports = __webpack_public_path__ + "static/media/3.e6debeb2.svg";